/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Content\CreateAccount\VerifyUser\VerifyUser.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Tuesday July 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday July 16th 2024 11:11:27 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useLang } from "Router/LangueProvider";
import { Fragment, useEffect, useState } from "react";
import Styles from "Content/CreateAccount/ValidationSuccess.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import { useLoaderData, useNavigate } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";

const ValidationSuccess = () => {
    const navigate = useNavigate();
    const {translator} = useLang();
    const [spinner, setSpinner] = useState(true);
    const success = useLoaderData();

    useEffect(() => {
        if (success !== undefined)
            setSpinner(false);
    }, [success]);

    return (
        <div className={`${Styles.createAccountPage}`}>
            {
                spinner ?
                    <div className={`${Styles.spinnerHolder}`}>
                        <LoadingScreen />
                    </div>
                    :
                    <Fragment>
                        <img loading="lazy" className={`${Styles.backgroundImg}`} src="/parkingImage.png" alt={translator.decode("image.background")} />
                        <div className={`${Styles.formHolder}`} >
                            {
                                success === 201 ?
                                <p>{translator.decode("users.validation_success")}</p>
                                :
                                <p>{translator.decode("users.validation_error")}</p>
                            }
                            <button className="btn btn-primary" onClick={() => navigate(RouterPathResolver.pathEntryPoint.path, {replace: true})}>{translator.decode("modal.backHome")}</button>
                        </div>
                    </Fragment>
            }
        </div>
    )
}

export default ValidationSuccess;

